import { copyObject } from '../../../../utils';

import { prepareJobAmount } from '../JobUtils';
import { setValueVariables } from '../DocumentsTab/DocumentVariables';
import { estimateIsDirty, lineItemsEstimate, getVariablesEsitmate } from '../DocumentsTab/Estimate/EstimateUtils'
import * as _ from 'lodash'
import { JobT } from '../../../../types/Job';
import { EstimateObj } from '../InitObjectJob';


export const FilterEstimate = {
    callback: (job: JobT): JobT => {
        let cloneJob = copyObject(job)
        if (!estimateIsDirty(cloneJob)) {
            let documentsClone = copyObject(job.documents)
            let lineItems = lineItemsEstimate(cloneJob);
            const estimates = prepareJobAmount(cloneJob)
            console.log("estimates",estimates)
            let estimateVariables = getVariablesEsitmate(cloneJob)
            estimateVariables = estimateVariables.length <= 0 ? EstimateObj.variables : estimateVariables
            if (estimates.length > 0 && !_.isEqual(lineItems, estimates)) {
                documentsClone.estimate.variables = setValueVariables('lineItems', estimates, estimateVariables)
                cloneJob.documents = documentsClone
            }
        }
        return cloneJob;
    },
    priority: 2,
    name: "documentEstimate"
}
